import React from "react";

const BRS = () => {
  return <div>BRS</div>;
};

export default BRS;
